import { ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { Fragment, useCallback } from 'react';
import FormRegion from 'system/geographic/components/region/form';
import { CommonConsulateCrumbs } from '../constants';
import { RegionForm } from 'system/geographic/pages/region/list/types';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const RegionNewPage = (): ReactElement => {
  const { post: insertRegion } = useHttpFetch(`${__MUNICIPALITY_API_URL__}/geo/regione`);

  const navigate = useNavigate();

  const onSave = useCallback(
    (formValues: RegionForm | undefined) => {
      insertRegion({
        nome: formValues?.name,
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/italia/regione');
      });
    },
    [insertRegion, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonConsulateCrumbs, { name: 'Nuova regione' }]} />
      <FormRegion title="Nuova regione" onSave={onSave} />
    </Fragment>
  );
};

RegionNewPage.displayName = 'Page new region';

export default RegionNewPage;
